var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2335_35441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8799 16.0078C22.7896 16.0078 23.2323 19.0949 23.2323 19.0949L23.2401 22.2933H30.0063V23.2536H20.5527C20.5527 23.2536 16.0156 22.7369 16.0156 29.9197C16.0156 37.1028 19.9757 36.848 19.9757 36.848H22.3391V33.5148C22.3391 33.5148 22.2117 29.5388 26.236 29.5388H32.9468C32.9468 29.5388 36.7172 29.6 36.7172 25.8803V19.7299C36.7172 19.7299 37.2898 16.0078 29.8799 16.0078ZM26.149 18.1587C26.3089 18.1585 26.4673 18.19 26.615 18.2514C26.7628 18.3128 26.897 18.4028 27.0101 18.5163C27.1231 18.6298 27.2128 18.7646 27.2739 18.9129C27.335 19.0613 27.3664 19.2202 27.3663 19.3808C27.3664 19.5413 27.335 19.7003 27.2739 19.8486C27.2128 19.997 27.1231 20.1317 27.0101 20.2453C26.897 20.3588 26.7628 20.4488 26.615 20.5102C26.4673 20.5715 26.3089 20.603 26.149 20.6029C25.9891 20.603 25.8308 20.5715 25.683 20.5102C25.5353 20.4488 25.4011 20.3588 25.288 20.2453C25.1749 20.1317 25.0853 19.997 25.0242 19.8486C24.963 19.7003 24.9317 19.5413 24.9318 19.3808C24.9317 19.2202 24.963 19.0613 25.0242 18.9129C25.0853 18.7646 25.1749 18.6298 25.288 18.5163C25.4011 18.4028 25.5353 18.3128 25.683 18.2514C25.8308 18.19 25.9891 18.1585 26.149 18.1587Z",
    fill: "url(#paint0_linear_2335_35441)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.082 43.9039C37.1723 43.9039 36.7296 40.8167 36.7296 40.8167L36.7218 37.6185H29.9555V36.6582H39.4091C39.4091 36.6582 43.9462 37.1748 43.9462 29.9918C43.9462 22.8089 39.9861 23.0636 39.9861 23.0636H37.6227V26.3967C37.6227 26.3967 37.7501 30.3727 33.7258 30.3727H27.015C27.015 30.3727 23.2446 30.3116 23.2446 34.0314V40.1818C23.2446 40.1818 22.6721 43.9039 30.0819 43.9039H30.082ZM33.8129 41.7532C33.653 41.7534 33.4946 41.7219 33.3469 41.6605C33.1991 41.5991 33.0649 41.5091 32.9518 41.3956C32.8388 41.2821 32.7491 41.1473 32.688 40.999C32.6269 40.8506 32.5955 40.6916 32.5956 40.5311C32.5955 40.3706 32.6269 40.2116 32.688 40.0632C32.7491 39.9149 32.8387 39.7801 32.9518 39.6666C33.0649 39.553 33.1991 39.463 33.3469 39.4016C33.4946 39.3403 33.653 39.3087 33.8129 39.3089C33.9728 39.3087 34.1311 39.3403 34.2789 39.4016C34.4266 39.463 34.5608 39.553 34.6739 39.6665C34.787 39.78 34.8766 39.9148 34.9377 40.0632C34.9989 40.2115 35.0302 40.3705 35.0301 40.531C35.0302 40.6915 34.9989 40.8505 34.9377 40.9989C34.8766 41.1472 34.787 41.282 34.6739 41.3955C34.5608 41.509 34.4266 41.599 34.2789 41.6604C34.1311 41.7218 33.9728 41.7534 33.8129 41.7532Z",
    fill: "url(#paint1_linear_2335_35441)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2335_35441",
    x1: 284.42,
    y1: 266.917,
    x2: 1674.03,
    y2: 1637.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2335_35441",
    x1: 419.41,
    y1: 451.957,
    x2: 1911.41,
    y2: 1856.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2335_35441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow24);
export default __webpack_public_path__ + "static/media/row-2-4.2f8ed71b2d7c436b333752c145f71347.svg";
export { ForwardRef as ReactComponent };